import React from "react";
import { TextField } from "@origin-digital/ods-core";
import { useFormikContext } from "formik";
import { UpdateEligibilityFormValues } from "./types";

interface EligibilityTextFieldProps {
  id: string;
  label: string;
  value: string;
  hasError?: boolean;
  readOnly?: boolean;
  fieldName: string;
  helperText?: string;
  maxLength?: string;
}

export const EligibilityTextField: React.FC<EligibilityTextFieldProps> = ({
  id,
  label,
  value,
  hasError = false,
  fieldName,
  helperText,
  readOnly = false,
  maxLength,
}) => {
  const { setFieldValue } = useFormikContext<UpdateEligibilityFormValues>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    console.log(`Field ${fieldName} changed to:`, newValue);
    setFieldValue(fieldName, newValue);
  };

  return (
    <TextField
      id={id}
      label={label}
      value={value}
      onChange={handleChange}
      hideHelperTextSpace
      error={hasError}
      helperText={helperText}
      disabled={readOnly}
      {...(maxLength ? { maxLength } : {})}
    />
  );
};
